import { createSelector } from 'reselect';

const selectUserState = (state) => state.user;

const isRemoteDataInitialized = (isLoading, hasErrored, remoteData) =>
  !isLoading && (hasErrored || remoteData !== undefined);

export const selectIsLoading = createSelector(
  selectUserState,
  (userState) => userState.isLoading,
);

export const selectHasErrored = createSelector(
  selectUserState,
  (userState) => undefined !== userState.error,
);

const selectRemoteData = createSelector(
  [
    selectUserState,
    selectHasErrored,
  ],
  (userState, hasErrored) =>
    ((!hasErrored) ? userState.remoteData : undefined),
);

const selectAuthentication = createSelector(
  [selectUserState],
  ({ authentication }) => authentication,
);

export const selectAuthenticationIsLoading = createSelector(
  selectAuthentication,
  (userState) => userState.isLoading,
);

export const selectAuthenticationHasErrored = createSelector(
  selectAuthentication,
  (userState) => undefined !== userState.error,
);

const selectAuthenticationRemoteData = createSelector(
  [
    selectAuthentication,
    selectAuthenticationHasErrored,
  ],
  (userState, hasErrored) =>
    ((!hasErrored) ? userState.remoteData : undefined),
);

export const selectAuthenticationIsInitialized = createSelector(
  [
    selectAuthenticationIsLoading,
    selectAuthenticationHasErrored,
    selectAuthenticationRemoteData,
  ],
  isRemoteDataInitialized,
);

export const selectIsInitialized = createSelector(
  [
    selectIsLoading,
    selectHasErrored,
    selectRemoteData,
  ],
  isRemoteDataInitialized,
);

export const selectUUID = createSelector(
  selectRemoteData,
  (remoteData) => (undefined !== remoteData ? remoteData.uuid : undefined),
);

export const selectIsLoggedIn = createSelector(
  selectUUID,
  (uuid) => undefined !== uuid,
);
